module.exports = __webpack_public_path__ + "static/media/error1.a6a905c4.svg";